<template>
    <div>
        <el-form ref="form" :model="row" label-width="0" method="PUT">
            <el-form-item>
                <el-upload
                    class="upload-demo"
                    ref="upload"
                    :action="action"
                    :on-success="onUploadSuccess"
                    :on-change="onUploadChange"
                    :show-file-list="showList"
                    :http-request="customUpload"
                    :auto-upload="false">
                    <el-button slot="trigger" size="small" type="primary">{{ $strings('word/do_upload_choose') }}
                    </el-button>
                    <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload"
                               :loading="uploading"
                               :disabled="disabled">
                        {{ $strings('word/do_upload') }}
                    </el-button>
                    <div slot="tip" class="el-upload__tip">{{ $strings('word/do_upload_hint') }}</div>
                    <transition name="el-fade-in">
                        <el-button v-show="showReset" size="small" @click="onReset">{{
                                $strings('word/reset')
                            }}
                        </el-button>
                    </transition>
                </el-upload>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>

import axios from "../api/instance";
import {FetchUploaderLink} from "../api/uploader/api";

const maxFileSize = 1024 * 1024;

export default {
    name: "uploader",
    props: ['action'],
    data() {
        return {
            row: {},
            uploading: false,
            disabled: true,
            showList: false,
            showReset: false,
        }
    },
    methods: {
        onReset() {
            this.disabled = false;
            this.showReset = false;
            this.$refs.upload.clearFiles();
            this.$emit('uploadReset');
        },
        onUploadSuccess() {
            this.disabled = true;
            this.showReset = true;
            this.uploading = false;
            this.$notify.success({title: 'SUCCESS', message: 'File is processing'});
            this.$emit('uploadSuccess', this.row);
        },
        onUploadChange(file) {
            if (file && file.size > maxFileSize) {
                this.$notify.error({title: 'ERROR', message: 'File too large'})
                this.showList = false;
            } else {
                this.disabled = false;
                this.row.file_name = file.name;
                this.showList = true;
            }
        },
        submitUpload() {
            this.uploading = true;
            FetchUploaderLink({action: this.action}).then((resp) => {
                this.uploadAction = Buffer.from(resp.data.data.sign, 'base64');
                this.row.file_link = resp.data.data.file_link;
                this.$nextTick(() => {
                    this.$refs.upload.submit();
                })
            });
        },
        customUpload(args) {
            axios({method: 'put', data: args.file, url: this.uploadAction, withCredentials: false}).then(() => {
                this.onUploadSuccess();
            })
        },
    }
}
</script>

<style scoped>

</style>